import type { RouteRecordRaw } from "vue-router"

const SudokuSolver = () => import("./sudoku/SudokuSolver.vue")
const Settlers = () => import("./Settlers.vue")
const RhythmTapper = () => import("./RhythmTapper.vue")
const Drinks = () => import("./drinks/Drinks.vue")

const routes: RouteRecordRaw[] = [
  { path: "/various/sudoku/", component: SudokuSolver, name: "various:sudoku" },
  { path: "/various/settlers/", component: Settlers, name: "various:settlers" },
  {
    path: "/various/rhythm-tapper/",
    component: RhythmTapper,
    name: "various:rhythm-tapper",
  },
  { path: "/various/drinks/", component: Drinks, name: "various:drinks" },
]

export default routes
